"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThresholdLevel = void 0;
/**
 * Vista Diagnostics Log supported threshold level values
 */
var ThresholdLevel;
(function (ThresholdLevel) {
    ThresholdLevel[ThresholdLevel["TRACE"] = 0] = "TRACE";
    ThresholdLevel[ThresholdLevel["DEBUG"] = 1] = "DEBUG";
    ThresholdLevel[ThresholdLevel["INFO"] = 2] = "INFO";
    ThresholdLevel[ThresholdLevel["WARN"] = 3] = "WARN";
    ThresholdLevel[ThresholdLevel["ERROR"] = 4] = "ERROR";
    ThresholdLevel[ThresholdLevel["SILENT"] = 5] = "SILENT";
})(ThresholdLevel = exports.ThresholdLevel || (exports.ThresholdLevel = {}));
//# sourceMappingURL=threshold.js.map